import { useBadgeCelebration } from '../../../../hooks/useBadgeCelebration';

/**
 * Headless, app-wide watcher that celebrates badge unlocks the moment they
 * happen. Renders nothing; mount once inside {@link CelebrationProvider}.
 */
const BadgeCelebrationWatcher = (): null => {
	useBadgeCelebration();
	return null;
};

export default BadgeCelebrationWatcher;
